import axios from 'axios';
import { API_URL } from '../config';


export const getReportAttendance = async (
  token: string,
  { startDate, endDate }: { startDate: string, endDate: string },
  selectedUnit: number | null = null,
  selectedEmployees: number[] = [],
  page: number = 1, pageSize: number = 25,
  signal: AbortSignal | null = null,
  permission: string | null,
) => {

  const config: Record<string, any> = {};

  if(signal) {
    config.signal = signal;
  }

  if (permission) 
    config.permission = permission;

  const response = await axios.get(`${API_URL}/presenze/company/reports/attendance/`, {
        headers: {
            'Authorization': `${token}`,
        },
        params: {
            start_date: startDate,
            end_date: endDate,
            page,
            page_size: pageSize,
            ou: selectedUnit,
            employees: selectedEmployees.join(',')
        },
        ...config
  });
  return response.data;
};

export const getReportAttendanceOU = async (
    token: string,
    { startDate, endDate }: { startDate: string, endDate: string },
    selectedUnit: number | null = null,
    page: number = 1,
    pageSize: number = 25,
    ouId: number,
    signal: AbortSignal | null = null,
    permission: string | null,
  ) => {
    const config: Record<string, any> = {};

    if(signal) {
      config.signal = signal;
    }
  
    if (permission) 
      config.permission = permission;

    const params: any = {
        page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
        ou: selectedUnit,
        ou_id: ouId,
    };

    const response = await axios.get(`${API_URL}/presenze/company/reports/attendance/${ouId}/`, {
      headers: {
        Authorization: `${token}`,
      },
      params,
      ...config,
    });
  
    return response.data;
  };

export const getReportAttendanceWorkingAreas = async (
  token: string,
  { startDate, endDate }: { startDate: string; endDate: string },
  selectedWorkingArea: number | null = null,
  selectedEmployees: number[] = [],
  page: number = 1,
  pageSize: number = 25,
  signal: AbortSignal | null = null,
  permission: string | null
) => {
  const config: Record<string, any> = {};

  if (signal) {
    config.signal = signal;
  }

  if (permission) {
    config.permission = permission;
  }

  const params: Record<string, any> = {
    start_date: startDate,
    end_date: endDate,
    page,
    page_size: pageSize,
    employees: selectedEmployees.join(","),
  };

  if (selectedWorkingArea !== null && selectedWorkingArea !== undefined) {
    params.working_area = selectedWorkingArea;
  }

  const response = await axios.get(`${API_URL}/presenze/company/reports/attendance-working-areas/`,
    {
      headers: {
        'Authorization': token,
      },
      params,
      ...config,
    }
  );

  return response.data;
};


export const getReportAttendanceWorkingAreaDetail = async (
  token: string,
  { startDate, endDate }: { startDate: string; endDate: string },
  page: number = 1,
  pageSize: number = 25,
  workingAreaId: number,
  signal: AbortSignal | null = null,
  permission: string | null = null,
) => {
  const config: Record<string, any> = {};

  if (signal) {
    config.signal = signal;
  }

  if (permission) {
    config.permission = permission;
  }

  const response = await axios.get(`${API_URL}/presenze/company/reports/attendance-working-areas/${workingAreaId}/`,
    {
      headers: {
        'Authorization': token,
      },
      params: {
        start_date: startDate,
        end_date: endDate,
        page,
        page_size: pageSize,
      },
      ...config,
    }
  );

  return response.data;
};